import {
  ListCollections3ifInnerParams,
  UserGetInfoModel,
  UserTreeCollectionModel
} from '@aipb/personal-content/shared/model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { UserApiService } from '../../api';
import { FavoriteUserRepository } from './favorite-user.repository';

@Injectable({
  providedIn: 'root'
})
export class FavoriteUserService {
  constructor(private api: UserApiService, private repository: FavoriteUserRepository) {}

  public getInfo(): Observable<UserGetInfoModel> {
    this.repository.setLoading(true);
    return this.api.getInfo().pipe(
      tap((data) => {
        this.repository.init(data);
      }),
      finalize(() => {
        this.repository.setLoading(false);
      })
    );
  }

  public getUserListCollections3ifUrl(): string {
    return this.api.listCollections3if();
  }

  public getUserListCollections3ifInnerUrl(params: ListCollections3ifInnerParams): string {
    return this.api.listCollections3ifInner(params);
  }

  public listCollections(): Observable<UserTreeCollectionModel[]> {
    return this.api.listCollections();
  }
}
